import { render, staticRenderFns } from "./ItemFormCustom.vue?vue&type=template&id=0a766c5b&scoped=true&"
import script from "./ItemFormCustom.vue?vue&type=script&lang=js&"
export * from "./ItemFormCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a766c5b",
  null
  
)

export default component.exports